import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AddressModel, CountryModel, StateModel } from '@data-layer/models/common';
import { distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { GenericService } from '@services/generic.service';
import { ReplaySubject } from 'rxjs';
import { UntypedFormControl } from '@angular/forms';
import { MarineInsuranceFromToFormComponent } from '@shared/marine-insurance-shared/components';

@Component({
  selector: 'app-marine-insurance-from-to-view-card',
  templateUrl: './marine-insurance-from-to-view-card.component.html',
  styleUrls: ['./marine-insurance-from-to-view-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceFromToViewCardComponent implements OnInit, OnDestroy {
  @Input() public country: CountryModel;
  @Input() public state: StateModel;
  @Input() public city: string;
  @Input() public headerText: string;
  @Input() public bodyText: string;
  @Input() public bodyHintText: string;
  @Input() public countryFormControl: UntypedFormControl;
  @Input() public stateFormControl: UntypedFormControl;
  @Input() public cityFormControl: UntypedFormControl;
  @Input() public isHideState: boolean;
  @Input() public isErrored: boolean;

  @Output() public edit: EventEmitter<void> = new EventEmitter<void>();

  public isDesktop: boolean;

  @ViewChild(MarineInsuranceFromToFormComponent)
  private formComponentRef: MarineInsuranceFromToFormComponent;

  private destroy$: ReplaySubject<void> = new ReplaySubject<void>();

  constructor(private genericService: GenericService) {}

  public ngOnInit(): void {
    this.genericService.isDesktop$.pipe(distinctUntilChanged(), takeUntil(this.destroy$)).subscribe((isDesktop: boolean) => {
      this.isDesktop = isDesktop;
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  public updateInputsValidation(): void {
    if (!this.isDesktop) {
      this.formComponentRef.updateInputsValidation();
    }
  }

  public get isAddedData(): boolean {
    return !!this.state?.code || !!this.city;
  }

  public get address(): AddressModel {
    return new AddressModel({ country: this.country, state: this.state, city: this.city });
  }
}
